import { FEATURE_FLAGS } from '@vizit/constants';
import { useFeatureFlag } from './use-feature-flag';

/**
 * GRE-358: returns whether the Spark Images prompt box should be shown.
 *
 * Defaults to `false`: generations stay unprompted until the flag is
 * explicitly enabled. The API reads the same `spark-image-prompts` key and
 * drops a prompt while it is off, so hiding the box here keeps the two in step.
 */
function useShowSparkImagePrompts(): boolean {
  return useFeatureFlag(FEATURE_FLAGS.SPARK_IMAGE_PROMPTS, false);
}

export { useShowSparkImagePrompts };
